import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Module11Faq {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.dropdown = document.querySelectorAll('.module-11_faq .dropdown .dropdown_title');
    };

    let registerEvents = () => {
        for (let i = 0; i < cache.dropdown.length; i++) {
            cache.dropdown[i].addEventListener('click',toggledropdown);
        }
    };

    let toggledropdown = function() {
        const col = this.closest('.dropdown');
        
        if(!col.classList.contains('active')) {
            const parent = col.closest('.dropdown_container');
            const active = parent.querySelector('.dropdown.active');
            active.classList.remove('active');
            anime({
                targets: active.querySelector('.dropdown_content'),
                duration: 600,
                height: 0,
                easing: 'easeInOutCubic',
                complete: function() {
                    active.querySelector('.dropdown_content').style.display = "none";
                }
            });

            col.classList.add('active');
            const col_content = col.querySelector('.dropdown_content');
            col_content.style.display = "block";
            col_content.style.height = "auto";
            const height = col_content.offsetHeight;
            col_content.style.height = 0;

            anime({
                targets: col_content,
                duration: 600,
                height: height,
                easing: 'easeInQuad',
                complete: function() {
                    document.querySelector('body').classList.add('scroll');
                    anime({
                        targets: globalVar.scrollElement,
                        scrollTop: (globalVar.scrollElement.scrollTop+col.getBoundingClientRect().top),
                        duration: 600,
                        easing: 'easeOutQuad',
                        complete: function () {
                            document.querySelector('body').classList.remove('scroll');
                        }
                    });
                }
            });
        }
    }

    initFunc();
  };
}
export { Module11Faq }